import styled from 'styled-components';

export const InputStyled = styled.input`
  width: 100%;
  height: 100%;
  outline: none;
  border: 0;

  outline: none;

  &::placeholder {
    color: #d6d6d6;
  }
`;

export const InputContainer = styled.div`
  width: 100%;
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;

  border: 1px solid #d6d6d6;
  border-radius: 8px;
  padding: 0 12px;

  ${InputStyled}:hover {
    border-color: #5768ff;
  }
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 14px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  transition: color 0.2s;

  &:hover {
    color: #5768ff;
  }

  &:focus {
    outline: none;
  }
`;
